/**
 * this is the transport order state service to handle the state across the application
 **/
export default class TransferOrderStateService {
	/**
	 * define required services here
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector) {
		this.$storage = $injector.get('$localStorage');
		this.q = $injector.get('$q');
		this.$storage.transferOrderState = this.$storage.transferOrderState || {};
		this.$storage.transferOrderState.checkedFilters = this.$storage.transferOrderState.checkedFilters || [];
		this.$storage.transferOrderState.showDeletedItems = this.$storage.transferOrderState.showDeletedItems || false;
	}

	/**
	 * get all checked filters from localStorage
	 * @return {array} all checked filters
	 **/
	getCheckedFilters() {
		return _.filter(this.$storage.transferOrderState.checkedFilters, (obj) => {
			return obj.checked;
		});
	}

	/**
	 * store checked filters
	 * @param {Array} filters - Array with filter objects
	 **/
	setCheckedFilters(filters) {
		this.$storage.transferOrderState.checkedFilters = filters;
	}

	/**
	 * check if state is checked
	 * @param {Object} obj - filter objects
	 * @return {boolean} whether or not the current state is checked
	 **/
	isStateChecked(obj) {
		return _.some(this.$storage.transferOrderState.checkedFilters, {status: obj.status});
	}

	/**
	 * show deleted items or not
	 * @return {boolean} whether or not show deleted items
	 */
	getDeletedItemVisibility() {
		return this.$storage.transferOrderState.showDeletedItems;
	}

	/**
	 * set the visibility for deleted items
	 * @param {boolean} hidden
	 */
	setDeletedItemVisibility(hidden) {
		this.$storage.transferOrderState.showDeletedItems = hidden;
	}

	getTableOrder(){
		return this.$storage.transferOrderState.tableOrder;
	}
	saveTableOrder(order){
		this.$storage.transferOrderState.tableOrder = order;
	}
}
